import { Button } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as actions from '../../../state';
import { TYPE_TAB, STYLE_TAB } from './tabsConstants';

import styles from './styles.module.css';

const messages = defineMessages({
  BACK: {
    id: 'BACK',
    defaultMessage: 'Back',
  },
  ADD: {
    id: 'ADD',
    defaultMessage: 'Add',
  },
  NEXT: {
    id: 'NEXT',
    defaultMessage: 'Next',
  },
  DONE: {
    id: 'DONE',
    defaultMessage: 'Done',
  },
});

function StepFooter({
  backAction,
  origAlert,
  origSource,
  nextAction,
  saveAlert,
  saveChart,
  selectedTab,
  tabContent,
}) {
  const selectedChart = useSelector(actions.readStateSelectedChart);

  const handleAlertNext = () => {
    saveAlert();
    nextAction();
  };

  /* configuring a data source */
  if (tabContent === 'configureSource') {
    /* configuring a table source */
    if (['ResponsiveTable', 'ResponsiveGridTable'].includes(selectedChart.type)) {
      return (
        <div className={styles.nsStep}>
          <div style={{ flex: '3' }} />

          <Button color="primary" onClick={nextAction}>
            <FormattedMessage {...messages.DONE} />
          </Button>
        </div>
      );
    }

    if (origSource.index !== undefined && origSource.index !== null) { // configuring an existing source
      return (
        <div className={styles.nsStep}>
          <div style={{ flex: '3' }} />

          <Button color="primary" onClick={nextAction}>
            <FormattedMessage {...messages.DONE} />
          </Button>
        </div>
      );
    } // adding a new source

    return (
      <div className={styles.nsStep}>
        <div style={{ flex: '3' }} />

        <Button color="primary" onClick={nextAction}>
          <FormattedMessage {...messages.ADD} />
        </Button>
      </div>
    );
  }

  /* configuring columns on a table */
  if (tabContent === 'toggleColumns') {
    return (
      <div className={styles.nsStep}>
        <div style={{ flex: '3' }} />

        <Button color="primary" onClick={nextAction}>
          <FormattedMessage {...messages.DONE} />
        </Button>
      </div>
    );
  }

  /* configuring an alert */
  if (tabContent === 'configureAlert') {
    if (typeof origAlert.index !== 'undefined' && origAlert.index !== null) { // configuring an existing alert
      return (
        <div className={styles.nsStep}>
          <div style={{ flex: '3' }} />

          <Button color="primary" onClick={handleAlertNext}>
            <FormattedMessage {...messages.DONE} />
          </Button>
        </div>
      );
    } // configuring a new alert

    return (
      <div className={styles.nsStep}>
        <div style={{ flex: '3' }} />

        <Button color="primary" onClick={saveAlert}>
          <FormattedMessage {...messages.ADD} />
        </Button>
      </div>
    );
  }

  if (tabContent === 'selectStat') { // no footer when selecting a stat
    return '';
  }

  return (
    <div className={styles.nsStep}>
      {selectedChart.new === true && selectedChart.type !== 'header' && selectedTab > TYPE_TAB && (
        <Button color="primary" onClick={backAction}>
          <FormattedMessage {...messages.BACK} />
        </Button>
      )}

      <div style={{ flex: '1' }} />

      {selectedChart.new === true && selectedTab < STYLE_TAB && (
        <Button
          variant="contained"
          color="primary"
          onClick={nextAction}
          disabled={selectedChart.type === 'new'}
          style={{ marginRight: 6 }}
        >
          { tabContent === 'configureSource'
            ? <FormattedMessage {...messages.ADD} />
            : <FormattedMessage {...messages.NEXT} />}
        </Button>
      )}

      {(selectedTab === STYLE_TAB || selectedChart.new !== true) && (
        <Button
          variant="contained"
          color="primary"
          onClick={saveChart}
          style={{ marginRight: 6 }}
        >
          <FormattedMessage {...messages.DONE} />
        </Button>
      )}
    </div>
  );
}

export default StepFooter;
